const Style = {
  user: 'absolute top-1/2 -translate-y-2/4 right-6 z-10 flex items-center justify-center',
  name: 'text-right opacity-50 text-xs font-normal',
  avatar: 'ml-4 w-6 h-6 md:w-8 md:h-8 rounded-full',
  hoverNav: 'mt-[-0.4em]'
};

export default Style;
